import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getBars } from '../../actions/bar';
import BarItem from './BarItem';


const AllBars = ({
  auth,
  getBars,
  bar: {bars},
}) => {

  useEffect(() => {
    getBars();
  }, [getBars]);

  return (
    <div className='container'>
    <Row xs={1} md={3} className="g-4">
        {bars.map(bar => (
            <BarItem key={bar._id} bar={bar} />
        ))}
    </Row>
    </div>
  )
};

AllBars.propTypes = {
  getBars: propTypes.func.isRequired,
  bar: propTypes.object.isRequired,
  auth: propTypes.object.isRequired
};

const mapStateToProps = state => ({
  bar: state.bar,
  auth: state.auth
});

export default connect(mapStateToProps, { getBars })(AllBars);